<p-dialog
  [(visible)]="displayTerms"
  [autoZIndex]="true"
  [closable]="true"
  [draggable]="false"
  [modal]="true"
  [style]="{ width: '50vw' }"
  (onHide)="hide()"
  header="{{ 'app.user-form.registration-data-protection' | translate }}"
  styleClass="netz-long-dialog">
  <div class="terms-of-use-section">
    <p class="heading">
      <span class="text">{{ 'home.message.terms-of-use.heading-1' | translate }}</span>
      <br />
      <span class="text">{{ 'home.message.terms-of-use.heading-2' | translate }}</span>
    </p>
    <p class="paragraph">
      <span class="text">{{ 'home.message.terms-of-use.paragraph-1' | translate }}</span>
    </p>
    <br />

    <p class="paragraph">
      <span class="text">{{ 'home.message.terms-of-use.paragraph-2' | translate }}</span>
    </p>
    <p class="paragraph">
      <em>
        <span class="text">{{ 'home.message.terms-of-use.paragraph-3' | translate }}</span>
      </em>
    </p>
    <br />

    <p class="heading">
      <span class="text">{{ 'home.message.terms-of-use.heading-3' | translate }}</span>
    </p>
    <p class="paragraph">
      <span class="text">{{ 'home.message.terms-of-use.paragraph-4' | translate }}</span>
    </p>
    <br />

    <p class="paragraph">
      <em>
        <span class="text">{{ 'home.message.terms-of-use.paragraph-5' | translate }}</span>
        <br />
        <span class="text">{{ 'home.message.terms-of-use.paragraph-6' | translate }}</span>
        <br />
        <span class="text">{{ 'home.message.terms-of-use.paragraph-7' | translate }}</span>
        <br />
      </em>
    </p>
    <br />

    <p class="paragraph">
      <span class="text">{{ 'home.message.terms-of-use.paragraph-8' | translate }}</span>
      <span class="text">{{ 'home.message.terms-of-use.paragraph-9' | translate }}</span>
    </p>
    <br />

    <p class="heading">
      <span class="text">{{ 'home.message.terms-of-use.heading-4' | translate }}</span>
    </p>
    <br />

    <p class="heading">
      <span class="text">{{ 'home.message.terms-of-use.heading-5' | translate }}</span>
    </p>
    <p class="paragraph">
      <span class="text">{{ 'home.message.terms-of-use.paragraph-10' | translate }}</span>
    </p>
    <br />

    <p class="heading">
      <span class="text">{{ 'home.message.terms-of-use.heading-6' | translate }}</span>
    </p>
    <p class="paragraph">
      <span class="text">{{ 'home.message.terms-of-use.paragraph-11' | translate }}</span>
    </p>
    <br />

    <p class="heading">
      <span class="text">{{ 'home.message.terms-of-use.heading-7' | translate }}</span>
    </p>
    <p class="paragraph">
      <span class="text">{{ 'home.message.terms-of-use.paragraph-12' | translate }}</span>
    </p>
    <br />

    <ul class="paragraph">
      <li>
        <span class="text">{{ 'home.message.terms-of-use.list-1' | translate }}</span>
      </li>
      <li>
        <span class="text">{{ 'home.message.terms-of-use.list-2' | translate }}</span>
      </li>
      <li>
        <span class="text">{{ 'home.message.terms-of-use.list-3' | translate }}</span>
      </li>
      <li>
        <span class="text">{{ 'home.message.terms-of-use.list-4' | translate }}</span>
      </li>
      <li>
        <span class="text">{{ 'home.message.terms-of-use.list-5' | translate }}</span>
      </li>
      <li>
        <span class="text">{{ 'home.message.terms-of-use.list-6' | translate }}</span>
      </li>
      <li>
        <span class="text">{{ 'home.message.terms-of-use.list-7' | translate }}</span>
      </li>
      <li>
        <span class="text">{{ 'home.message.terms-of-use.list-8' | translate }}</span>
      </li>
    </ul>
    <br />

    <p class="paragraph">
      <span class="text">{{ 'home.message.terms-of-use.paragraph-13' | translate }}</span>
    </p>
    <br />

    <p class="heading">
      <span class="text">{{ 'home.message.terms-of-use.heading-8' | translate }}</span>
    </p>
    <br />

    <p class="paragraph">
      <span class="text">{{ 'home.message.terms-of-use.paragraph-14' | translate }}</span>
    </p>
    <br />

    <p class="heading">
      <span class="text">{{ 'home.message.terms-of-use.heading-9' | translate }}</span>
    </p>
    <p class="paragraph">
      <span class="text">{{ 'home.message.terms-of-use.paragraph-15' | translate }}</span>
    </p>
    <br />

    <p class="paragraph">
      <span class="text">{{ 'home.message.terms-of-use.paragraph-16' | translate }}</span>
    </p>
    <br />

    <p class="paragraph">
      <span class="text">{{ 'home.message.terms-of-use.paragraph-17' | translate }}</span>
    </p>
    <br />

    <p class="heading">
      <span class="text">{{ 'home.message.terms-of-use.heading-10' | translate }}</span>
    </p>
    <p class="paragraph">
      <span class="text">{{ 'home.message.terms-of-use.paragraph-18' | translate }}</span>
    </p>

    <p class="heading">
      <span class="text">{{ 'home.message.terms-of-use.heading-11' | translate }}</span>
    </p>
    <p class="paragraph">
      <span class="text">{{ 'home.message.terms-of-use.paragraph-19' | translate }}</span>
    </p>
    <br />

    <p class="heading">
      <span class="text">{{ 'home.message.terms-of-use.heading-12' | translate }}</span>
    </p>
    <p class="paragraph">
      <span class="text">{{ 'home.message.terms-of-use.paragraph-20' | translate }}</span>
    </p>
    <br />

    <p class="heading">
      <span class="text">{{ 'home.message.terms-of-use.heading-13' | translate }}</span>
    </p>
    <p class="paragraph">
      <span class="text">{{ 'home.message.terms-of-use.paragraph-21' | translate }}</span>
    </p>
    <br />

    <p class="heading">
      <span class="text">{{ 'home.message.terms-of-use.heading-14' | translate }}</span>
    </p>
    <p class="paragraph">
      <span class="text">{{ 'home.message.terms-of-use.paragraph-22' | translate }}</span>
    </p>
    <br />

    <p class="heading">
      <span class="text">{{ 'home.message.terms-of-use.heading-15' | translate }}</span>
    </p>
    <p class="paragraph">
      <span class="text">{{ 'home.message.terms-of-use.paragraph-23' | translate }}</span>
    </p>
    <br />

    <p class="heading">
      <span class="text">{{ 'home.message.terms-of-use.heading-16' | translate }}</span>
    </p>
    <p class="paragraph">
      <span class="text">{{ 'home.message.terms-of-use.paragraph-24' | translate }}</span>
    </p>
    <br />

    <p class="heading">
      <span class="text">{{ 'home.message.terms-of-use.heading-17' | translate }}</span>
    </p>
    <p class="paragraph">
      <span class="text">{{ 'home.message.terms-of-use.paragraph-25' | translate }}</span>
    </p>
    <br />

    <p class="paragraph">
      <span class="text">{{ 'home.message.terms-of-use.paragraph-26' | translate }}</span>
    </p>
  </div>
</p-dialog>
